import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from "react-redux";
import { Popup } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { LoadPanel } from 'devextreme-react/load-panel';
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { IDWarehouseLookupLayout } from '../../../../../common/lookups/Layouts/IdLayouts';
import { IMLocationLookupLayout } from '../../../../../common/lookups/Layouts/ImLayouts';
import { WMCodesLookupLayout } from '../../../../../common/lookups/Layouts/WMLayouts';
import { WM } from '../../../../../const/constants';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import axios from 'axios';
import notify from 'devextreme/ui/notify';
import { alert } from 'devextreme/ui/dialog';
import { ERROR_SEVERITY, formatErrorList } from '../../../../../common/apiErrors';
import { CONCURRENCY_HANDLED, getApiErrorMessage } from '../../../../../common/concurrency';

const runtimeParameter = JSON.stringify([
    { R_PLANWAREHOUSE: 'RWarehouse' }
]);
const locationLookupLayout = IMLocationLookupLayout({ moduleType: WM, runtimeParameter });
const IM="IM";
const resourcesCodeLayout = WMCodesLookupLayout({ codeType: '46' });
const PlannedAppointmentLayout = [
    {
        groupId: 1,
        label: "Plan/Appointment",
        fields: [
            {
                name: "DELIVERYPICKUPPLANNEDDATETIME",
                tableName: "WMTRANSACTIONHEADER",
                label: "From",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "DELIVERYPICKUPARRIVEDATETIME",
                tableName: "WMTRANSACTIONHEADER",
                label: "To",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "R_PLANWAREHOUSE",
                tableName: "WMTRANSACTIONHEADER",
                label: "WH",
                type: "lookup",
                layout: IDWarehouseLookupLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "R_PLANLOCATION",
                tableName: "WMTRANSACTIONHEADER",
                label: "Dock",
                type: "lookup",
                layout: IMLocationLookupLayout({ moduleType: IM, runtimeParameter }),
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "PLANRESOURCESCODE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Resources",
                type: "lookup",
                layout: resourcesCodeLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "PLANRESOURCESHOURS",
                tableName: "WMTRANSACTIONHEADER",
                label: "Resource Hours",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            }
        ]
    },
    {
        groupId: 1,
        label: "Plan/Appointment",
        fields: [
            {
                name: "PLANREFERENCE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Reference No.",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "TRANSFERTODISPATCH",
                tableName: "WMTRANSACTIONHEADER",
                label: "FM Transfer",
                type: "select",
                options: [""],
                required: false,
                visible: true,
                searchEnabled: false,
                isLabelChanged: false,
            },
            {
                name: "DISPATCHORDERNUMBER",
                tableName: "WMTRANSACTIONHEADER",
                label: "Dispatch #",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "CODCOMMENT",
                tableName: "WMTRANSACTIONHEADER",
                label: "Comment Flag",
                type: "select",
                options: [""],
                required: false,
                visible: true,
                searchEnabled: false,
                isLabelChanged: false,
            },
            {
                name: "COMMENT",
                tableName: "WMTRANSACTIONHEADER",
                label: "Comment",
                type: "textarea",
                required: false,
                visible: true,
                isLabelChanged: false,
            }
        ]
    }
];

const fmTransferOptions = [
    { Rowid: "N", Code: "No, FM Interface" },
    { Rowid: "Y", Code: "Yes, Create FM Transaction Record" },
    { Rowid: "D", Code: "Yes, Create FM Dispatch Object" },
    { Rowid: "B", Code: "Yes, Create Both FM Billing Record and FM Dispatch Object" }
];

const commentFlagOptions = [
    { Rowid: "T", Code: "Transaction Comment" },
    { Rowid: "P", Code: "Plan Comment" }
];

const PlannedAppointment = ({ visible, onClose, transactionRowId, accessToken, transactionNumber, oidc }) => {
    const [loading, setLoading] = useState(false);
    const [formFields, setFormFields] = useState({});
    const [transactionData, setTransactionData] = useState(null);
    const formRefs = useRef({});
    const currentUser = oidc?.user;
    const DYNAMICFORMSETTING = oidc?.user?.profile?.DYNAMICFORMSETTING;

    useEffect(() => {
        if (visible && transactionRowId) {
            loadTransaction();
        }
        if (!visible) {
            setFormFields({});
            setTransactionData(null);
        }
    }, [visible, transactionRowId]);

    const loadTransaction = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/wm/Transaction/GetTransactionByRowId?rowid=${transactionRowId}`,
                {
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            const data = response.data;
            setTransactionData(data);
            setFormFields({
                DELIVERYPICKUPPLANNEDDATETIME: data?.DELIVERYPICKUPPLANNEDDATETIME || null,
                DELIVERYPICKUPARRIVEDATETIME: data?.DELIVERYPICKUPARRIVEDATETIME || null,
                R_PLANWAREHOUSE: data?.R_PLANWAREHOUSE || null,
                R_PLANLOCATION: data?.R_PLANLOCATION || null,
                PLANRESOURCESCODE: data?.PLANRESOURCESCODE || null,
                PLANRESOURCESHOURS: data?.PLANRESOURCESHOURS || null,
                PLANREFERENCE: data?.PLANREFERENCE || null,
                TRANSFERTODISPATCH: data?.TRANSFERTODISPATCH || 'N',
                DISPATCHORDERNUMBER: data?.DISPATCHORDERNUMBER || null,
                CODCOMMENT: data?.CODCOMMENT || null,
                COMMENT: data?.COMMENT || null
            });
        } catch (error) {
            console.error('Error loading transaction:', error);
            alert("Error loading transaction.", "Error");
        } finally {
            setLoading(false);
        }
    };

    const handleFieldChange = useCallback((name, value) => {
        if (name === 'R_PLANWAREHOUSE') {
            if (formRefs.current['R_PLANLOCATION']) {
                formRefs.current['R_PLANLOCATION'].instance().option('value', null);
            }
            if (value) {
                var locationDataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                        loadParams: {
                            locationTypes: 'L',
                            warehouseRowId: value
                        },
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                if (formRefs.current['R_PLANLOCATION']) {
                    formRefs.current['R_PLANLOCATION'].instance().option('dataSource', locationDataSource);
                }
            }
        }
    }, [accessToken]);

    const handleFormLoad = useCallback(() => {
        if (formRefs.current['TRANSFERTODISPATCH']) {
            const newOptions = fmTransferOptions.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            formRefs.current['TRANSFERTODISPATCH'].instance().option('dataSource', newOptions);
            formRefs.current['TRANSFERTODISPATCH'].instance().option('valueExpr', 'id');
            formRefs.current['TRANSFERTODISPATCH'].instance().option('displayExpr', 'name');
        }
        if (formRefs.current['CODCOMMENT']) {
            const newOptions = commentFlagOptions.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            formRefs.current['CODCOMMENT'].instance().option('dataSource', newOptions);
            formRefs.current['CODCOMMENT'].instance().option('valueExpr', 'id');
            formRefs.current['CODCOMMENT'].instance().option('displayExpr', 'name');
        }
    }, []);

    const handleSave = async () => {
        if (!transactionData) return;
        setLoading(true);
        try {
            const { Profile, Carrier, isLineItemExist, UserValidationMessage, ItemTotalQuanity, ItemTotalChargeAmount, TotalChargesCount, CustomerAddress, CustomerCreditLimit, CustomerCreditBalance, CustomerCreditRemaning, ...cleanData } = transactionData;
            const updatedData = { ...cleanData, DELIVERYPICKUPPLANNEDDATETIME: formFields.DELIVERYPICKUPPLANNEDDATETIME, DELIVERYPICKUPARRIVEDATETIME: formFields.DELIVERYPICKUPARRIVEDATETIME, R_PLANWAREHOUSE: formFields.R_PLANWAREHOUSE, R_PLANLOCATION: formFields.R_PLANLOCATION, PLANRESOURCESCODE: formFields.PLANRESOURCESCODE, PLANRESOURCESHOURS: formFields.PLANRESOURCESHOURS, PLANREFERENCE: formFields.PLANREFERENCE, TRANSFERTODISPATCH: formFields.TRANSFERTODISPATCH, DISPATCHORDERNUMBER: formFields.DISPATCHORDERNUMBER, CODCOMMENT: formFields.CODCOMMENT, COMMENT: formFields.COMMENT };
            const res = await axios.put(
                `${window._env_.REACT_APP_APIS}/wm/Transaction/PutTransaction`,
                updatedData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            // Reaching here means the save happened — a profile-rule refusal is now a real 400 and lands in
            // the catch below. See Transportation.js for the full note.
            notify("Plan/Appointment saved successfully.", "success", 3000);
            onClose();
        } catch (error) {
            console.error('Error saving:', error);
            if (error?.[CONCURRENCY_HANDLED]) {
                return;
            }
            alert(formatErrorList(error?.response?.data?.errors, ERROR_SEVERITY.ERROR)
                || getApiErrorMessage(error, "Error saving plan/appointment."), "Error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Popup
            visible={visible}
            onHiding={onClose}
            dragEnabled={true}
            hideOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            title={`WM Plan/Appointments Entry (${transactionNumber || ''})`}
            width={650}
            height={500}
        >
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={loading}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
           
            <style>{`.planned-appointment-form .flex-container { display: block !important; }`}</style>
            <div className="planned-appointment-form">
                <FormField
                    currrentUser={currentUser}
                    layoutId='1D5DE8E3-BC98-44E8-959D-95024AA2EA75'
                    layoutName='PlannedAppointmentForm'
                    defaultFormSchema={PlannedAppointmentLayout}
                    formFields={formFields}
                    setformFields={setFormFields}
                    handleFieldValueChange={handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleFormLoad}
                />
                 <div >
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '10px', borderTop: '1px solid #eee' }}>
                    <Button text="Save" type="default"   onClick={handleSave} />
                    <Button text="Cancel" type="normal" icon="close" onClick={onClose} />
                </div> 
                </div>
                  
            </div>
        </Popup>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(PlannedAppointment);
